import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from './AuthContext';
import Loading from './Loading';

/**
 * AuthGuard component that protects routes requiring authentication
 * Automatically redirects to login if user is not authenticated
 * 
 * Usage:
 *   <AuthGuard>
 *     <YourProtectedComponent />
 *   </AuthGuard>
 */
export default function AuthGuard({ children }) {
  const { isAuthenticated, isChecking, requireAuth } = useAuth();

  useEffect(() => {
    if (!isChecking && !isAuthenticated) {
      requireAuth();
    }
  }, [isChecking, isAuthenticated, requireAuth]);

  if (isChecking) {
    return <Loading message="Authenticating..." />;
  }

  if (!isAuthenticated) {
    // Will redirect to login, show loading in the meantime
    return <Loading message="Redirecting to login..." />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

